import {useAtomValue} from 'jotai';
import {authStore} from '../../Stores/authStore';

export default function useAuth() {
    return useAtomValue(authStore, 'root');
}
